import inMemoryJwt from "../../auth/inMemoryJwt"
import { urlServer } from "../../config/GlobalConstant"

export const createAdd = (body, history) => async dispatch => {

    await fetch(`${urlServer}adminadvertising/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: body
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                history.push("/Admin/Advertisings")
            }
        })
        .catch(error => {
            console.log()
        })
}
export const listeAdds = () => async dispatch => {

    await fetch(`${urlServer}adminadvertising/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: "GET_ADDS",
                    payload: respJson.data
                })
            }

        })
        .catch(error => {
            console.log()
        })
}


export const deleteAdd = (id,close) => async dispatch => {

    await fetch(`${urlServer}adminadvertising/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            advertisingId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: "DELETE_ADD",
                    payload: id
                })
                close()
            }

        })
        .catch(error => {
            console.log()
        })
}
export const getAdd = (id) => async dispatch => {

    await fetch(`${urlServer}adminadvertising/get-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            advertisingId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: "GET_ADD",
                    payload: respJson.data
                })
            }

        })
        .catch(error => {
            console.log()
        })
}

export const editAdd = (body,history) => async dispatch => {

    await fetch(`${urlServer}adminadvertising/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: body
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: "GET_ADD",
                    payload: respJson.data
                })
                history.push("/Admin/Advertisings")
            }

        })
        .catch(error => {
            console.log()
        })
}
export const clearAdd = () => dispatch => {

    dispatch({
        type: "CLEAR_ADD"
    })
}

